<template>
  <div
    ref="embedMapComponentRef"
    v-html="embedMap"
    class="embed-map-container"
  />
</template>

<script>
export default {
  name: 'EmbedMapComponent',
  props: {
    embedMap: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  mounted () {
    this.getEmbedMapSize()
  },
  updated () {
    this.getEmbedMapSize()
  },
  methods: {
    getEmbedMapSize () {
      const container = this.$refs.embedMapComponentRef
      if (!container) {
        return
      }

      const iframe = container.querySelector('iframe')

      if (!iframe) {
        return
      }

      iframe.style.width = this.width
      iframe.style.height = this.height
    }
  }
}
</script>

<style scoped>
.embed-map-container {
  width: 100% !important;
  height: 100% !important;
}
</style>
